<template>
  <el-form :model="form" label-width="160px">
    <el-form-item label="Date du ramassage">
      <el-date-picker v-model="pickupDate" type="date" />
    </el-form-item>

    <el-form-item label="Heure prête à partir de">
      <el-time-picker v-model="readyAtPickupTime" format="HH:mm" />
    </el-form-item>

    <el-form-item label="Heure limite de ramassage">
      <el-time-picker v-model="readyUntilPickupTime" format="HH:mm" />
    </el-form-item>

    <el-form-item
      :label="'Poids total (' + shipment.packaging_properties.weight.unit + ')'"
    >
      <el-input
        v-model.number="form.pickup_details.package_details.weight.value"
      />
    </el-form-item>

    <el-form-item label="Nombre de colis">
      <el-input v-model.number="form.pickup_details.package_details.quantity" />
    </el-form-item>

    <el-form-item label="Lieu de ramassage">
      <el-select
        v-model="form.pickup_details.pickup_location"
        placeholder="Sélectionner"
      >
        <el-option
          v-for="loc in pickupLocations"
          :key="loc"
          :label="$t('ELIXIO_CONNECT.' + loc)"
          :value="loc"
        />
      </el-select>
      <!-- <el-select v-model="form.pickup_details.pickup_location" placeholder="Sélectionner">
        <el-option
          v-for="loc in pickupLocations"
          :key="loc.value"
          :label="loc.label"
          :value="loc.value"
        />
      </el-select> -->
    </el-form-item>

    <el-form-item label="Instructions">
      <el-input
        v-model="form.pickup_details.pickup_instructions"
        type="textarea"
      />
    </el-form-item>

    <div class="flex gap-2">
      <el-button type="primary" @click="submitPickup"
        >Créer le pickup</el-button
      >
      <el-button @click="$emit('cancel')">Annuler</el-button>
    </div>
  </el-form>
</template>

<script>
import {
  PICKUP_LOCATIONS,
  DEFAULT_PICKUP_LOCATION,
} from "../../constants/shipment";

import { DatePicker, TimePicker } from "element-ui";
import { Form, FormItem, Card, Button, Select, Option, Divider } from "element-ui";

export default {
  name: "PickupForm",
  components: {
    [DatePicker.name]: DatePicker,
    [TimePicker.name]: TimePicker,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Card.name]: Card,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Divider.name]: Divider,
  },
  props: {
    shipment: { type: Object, required: true },
    initialDetails: { type: Object, required: true },
  },
  data() {
    return {
      defaultPickupLocation: DEFAULT_PICKUP_LOCATION,
      form: JSON.parse(JSON.stringify(this.initialDetails)),
      pickupLocations: PICKUP_LOCATIONS,
    };
  },
  computed: {
    pickupDate: {
      get() {
        const d = this.form.pickup_details.date;
        return new Date(d.year, d.month - 1, d.day);
      },
      set(val) {
        this.form.pickup_details.date = {
          year: val.getFullYear(),
          month: val.getMonth() + 1,
          day: val.getDate(),
        };
      },
    },
    readyAtPickupTime: {
      get() {
        const t = this.form.pickup_details.ready_at;
        if (!t || typeof t.hour !== "number" || typeof t.minute !== "number") {
          return null;
        }
        return new Date(0, 0, 0, t.hour, t.minute);
      },
      set(val) {
        if (val instanceof Date) {
          this.form.pickup_details.ready_at = {
            hour: val.getHours(),
            minute: val.getMinutes(),
          };
        } else {
          this.form.pickup_details.ready_at = { hour: 0, minute: 0 };
        }
      },
    },
    readyUntilPickupTime: {
      get() {
        const t = this.form.pickup_details.ready_until;
        if (!t || typeof t.hour !== "number" || typeof t.minute !== "number") {
          return null;
        }
        return new Date(0, 0, 0, t.hour, t.minute);
      },
      set(val) {
        if (val instanceof Date) {
          this.form.pickup_details.ready_until = {
            hour: val.getHours(),
            minute: val.getMinutes(),
          };
        } else {
          this.form.pickup_details.ready_until = { hour: 0, minute: 0 };
        }
      },
    },
  },
  methods: {
    async submitPickup() {
      // convertir en string AVANT l’envoi
      this.form.pickup_details.package_details.weight.value =
        String(this.form.pickup_details.package_details.weight.value);

      this.form.pickup_details.package_details.quantity =
        String(this.form.pickup_details.package_details.quantity);
        if(!this.form.pickup_details.pickup_location){
          this.$notify({
            type: "danger",
            message: this.  $t("ERRORS.LOCATION_REQUIRED"),
          });
          return;
        }
      await this.$store.dispatch("elixioConnectModule/createPickup", {
        shipmentId: this.shipment.id,
        pickupDetails: this.form,
      });
      this.$emit("submitted");
    },
  },
};
</script>
